import { jsx, jsxs } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { Icon } from "../../Icon";
import Typography from "../../Typography";
import { getGroupColors } from "../../../shared/helpers";
import { SlotBox } from "./SlotBox";
import { AvatarSlot, AvatarSlotImageContainer, SlotAvatarBox, PlaceholderImg } from "../Avatar.styled";
import { useAvatarContext } from "../context/AvatarContext";
import { useAvatarColors } from "../hooks/useAvatarColors";
import { useImageLoad } from "../hooks/useImageLoad";
import { abbreviate } from "../utils";
const SlotAvatar = (props) => {
  const {
    shape = "square",
    color,
    gradient,
    position,
    text,
    icon,
    src,
    alt,
    onError,
    ...rest
  } = props;
  const { size, parentBg, theme } = useAvatarContext();
  const palette = getGroupColors(theme, parentBg);
  const colorBoxBg = palette.main;
  const slotOverlay = palette.transparent;
  const slotTokens = theme?.avatarV2;
  const avatarSize = size && slotTokens?.slot?.variant?.avatar?.size[size];
  const boxSize = avatarSize && slotTokens?.size[avatarSize];
  const iconSize = avatarSize && slotTokens?.icon[avatarSize];
  const borderRadius = size && slotTokens?.slot?.variant?.avatar?.borderRadius[shape]?.size[size];
  const border = size && slotTokens?.slot?.border[size] || 0;
  const typography = avatarSize && slotTokens?.typography[avatarSize];
  const letterCount = avatarSize && slotTokens?.letterCount[avatarSize];
  const abbreviation = typeof text === "string" ? abbreviate(text, typeof letterCount === "number" ? letterCount : 2) : "";
  const borderImage = avatarSize && slotTokens?.borderRadius[shape]?.size[avatarSize];
  const { background } = useAvatarColors(parentBg, gradient);
  const { loaded, error: imageError } = useImageLoad(src, onError);
  const slotAvatarBoxStyle = useMemo(() => {
    return {
      background: gradient && !loaded ? background : slotOverlay,
      borderRadius: `${borderImage}px`
    };
  }, [gradient, loaded, background, slotOverlay, borderImage]);
  return /* @__PURE__ */ jsx(SlotBox, { position, ...rest, children: /* @__PURE__ */ jsx(
    AvatarSlot,
    {
      boxBg: colorBoxBg,
      borderRadius,
      border,
      boxSize,
      borderColor: colorBoxBg,
      children: /* @__PURE__ */ jsxs(SlotAvatarBox, { style: slotAvatarBoxStyle, children: [
        icon && React.isValidElement(icon) ? /* @__PURE__ */ jsx(Icon, { icon, color, size: iconSize }) : /* @__PURE__ */ jsx(Typography, { variant: typography, color, children: abbreviation }),
        src && !imageError && /* @__PURE__ */ jsx(AvatarSlotImageContainer, { borderSize: border, isLoaded: loaded, children: /* @__PURE__ */ jsx(
          PlaceholderImg,
          {
            src,
            alt,
            borderRadius: borderImage
          }
        ) })
      ] })
    }
  ) });
};
export {
  SlotAvatar
};
